import Vue from 'vue';
import Router from 'vue-router';

const FeaturesList = () => import('@/components/FeaturesList.vue');
// const AuthenticationCredentials = () => import('@/components/AuthenticationCredentials.vue');
const AccountManage = () => import('@/components/AccountManage.vue');
const AccountEmailVerify = () => import('@/components/AccountEmailVerify.vue');
const PasswordReset = () => import('@/components/PasswordReset.vue');
const PasswordForgot = () => import('@/components/PasswordForgot.vue');
const AccountCreate = () => import('@/components/AccountCreate.vue');
const SignIn = () => import('@/components/SignIn.vue');
const ActivitiesList = () => import('@/components/ActivitiesList.vue');

Vue.use(Router);

const router = new Router({
  routes: [
    {
      path: '/',
      name: 'FeaturesList',
      component: FeaturesList,
      meta: { requiresAuth: true },
    },
    {
      path: '/account',
      name: 'AccountManage',
      component: AccountManage,
      meta: { requiresAuth: true },
    },
    // {
    //   path: '/auth',
    //   name: 'AuthenticationCredentials',
    //   component: AuthenticationCredentials,
    // },
    // remove
    {
      path: '/create-account',
      name: 'AccountCreate',
      component: AccountCreate,
    },
    // remove
    {
      path: '/sign-in',
      name: 'SignIn',
      component: SignIn,
    },
    {
      path: '/a',
      name: 'AccountEmailVerify',
      component: AccountEmailVerify,
    },
    {
      path: '/reset-password',
      name: 'PasswordReset',
      component: PasswordReset,
    },
    {
      path: '/forgot-password',
      name: 'PasswordForgot',
      component: PasswordForgot,
    },
    {
      path: '/activities',
      name: 'ActivitiesList',
      component: ActivitiesList,
      meta: { requiresAuth: true },
    },
  ],
});

router.beforeEach((to, from, next) => {
  console.log(to, from, next);
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!localStorage.getItem('token')) {
      next({
        path: '/sign-in',
        query: { redirect: to.fullPath },
      });
    } else {
      next();
    }
  } else {
    next();
  }
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js